import { client } from './index';

export type WebsocketRuntimeConfig = {
  host: string;
  stage: string;
};

type WebsocketConfigResponse = {
  websocketHost: string;
  websocketStage: string;
};

let cached: Promise<WebsocketRuntimeConfig> | null = null;

export const getWebsocketConfig = (): Promise<WebsocketRuntimeConfig> => {
  if (!cached) {
    cached = client
      .get<WebsocketConfigResponse>('/websocket-config')
      .then((res) => ({
        host: res.data.websocketHost,
        stage: res.data.websocketStage,
      }))
      .catch((err) => {
        cached = null;
        throw err;
      });
  }
  return cached;
};
